module.exports = require("@seddi/geometry");